// extracted by mini-css-extract-plugin
export default {"root":"YwBdtCyE","withPlaceholder":"x+TpOjut"};